module.exports = __webpack_public_path__ + "videos/mts-main-products-webinars.8edee67.mp4";